<script>
import StudentWritingSubmission from "@/view/pages/classes/StudentWritingSubmission.vue";
import StudentSpeakingSubmission from "@/view/pages/classes/StudentSpeakingSubmission.vue";
import Evaluation from "@/view/pages/classes/Evaluation.vue";
import {SPEAKING, WRITING} from '@/common/courseTemplate.js'
import {getEvaluationTemplate, isV3Rubric} from '@/common/markingTemplate'
import {GET_EXAM_ANSWER_MIDTERM_TEST, SAVE_RESULT, GET_WRITING_AI_RESULT} from "@/core/services/store/course/classes.module";
import {GET_SPEAKING_AI_RESULT} from "@/core/services/store/marking/marking.module";
import {SET_BREADCRUMB} from "@/core/services/store/breadcrumbs.module";
export default {
  name: "MarkMidtermTest",
  components: {Evaluation, StudentSpeakingSubmission, StudentWritingSubmission},
  data() {
    return {
      classLevel: 1,
      markingData: [],
      studentName: this.$route.query.name,
      markingDataIndex: 0,
      SPEAKING,
      WRITING,
      evaluationFollowClass: null,
      loading: false,
      newTemplate: null,
      isLowBand: false,
      markingVersion: 2,
    }
  },
  computed: {
    isEntrance() {
      const { isEntrance } = this.$route.query;
      return isEntrance === true || isEntrance === 'true';
    },
    currenMarkingData() {
      if (this.markingData.length === 0) {
        return null
      }
      return this.markingData[this.markingDataIndex]
    },
    isFinishedEvaluation() {
      const missingSkills = [];

      // 1. Nếu có gian lận (cheating), thì phải có comment và PlagiarismRate
      if (this.currenMarkingData?.cheating && this.currenMarkingData?.cheating.isCheating === true) {
        if (!this.currenMarkingData?.cheating?.comment || this.currenMarkingData?.cheating?.PlagiarismRate == null) {
          return {
            done: false,
            missingSkills: ['cheating.comment hoặc cheating.PlagiarismRate']
          };
        }
      }
      const skills = this.currenMarkingData?.evaluation?.items || [];
      skills.forEach((skill) => {
        const { label, comment_detail, items } = skill;
        if (!comment_detail) {
          missingSkills.push(`${label}: thiếu comment_detail`);
        }
        skill.items.forEach((subItem) => {
          if (subItem?.criterion_score == null) {
            missingSkills.push(`${label}: thiếu criterion_score ở "${subItem.label}"`);
          }
        });
      });
      return {
        done: missingSkills.length === 0,
        missingSkills
      };
    },
    checkDisabledNext() {
      if(!this.currenMarkingData?.didStudentDo)return false
      return !this.isFinishedEvaluation.done
    }
  },
  methods: {
    backQuestion() {
      this.markingDataIndex--
    },
    nextQuestion() {
      this.markingDataIndex++
    },
    redirectToTaskDetailPage(){
      this.$router.push({
        name: 'TaskManageDetail',
        params: { taskId: this.$route.query.taskId },
        query: {
          marking_exam_retake_id: this.$route.params.id,
          classroom_id: this.$route.query.classId,
          is_midTerm: this.$route.query.is_midTerm,
        },
      });
    },
    async saveAll() {
      this.loading = true
      const SpeakingPart = this.markingData.find((data) => data?.testType === this.SPEAKING)
      const WritingsPart = this.markingData.filter((data) => data?.testType === this.WRITING)
      const payload = {
        marking_exam_retake_id: this.$route.params.id,
        ...(SpeakingPart ? { speakings: this.transformDataToSendAPI(SpeakingPart) } : {}),
        writings: WritingsPart.map((writing) => this.transformDataToSendAPI(writing)),
        version: this.markingVersion
      }
      try {
       await this.$store.dispatch(SAVE_RESULT,payload)
        this.$message({
          message: 'Chấm bài thành công',
          type: 'success',
          duration: 5000
        });
       const classId = this.$route.query.classId
        const previousPage = this.$route.query.previousPage
        if (previousPage){
          if (previousPage === 'TaskManageDetail') {
            await this.redirectToTaskDetailPage()
            return;
          }
          await this.$router.push({name:`${previousPage}`})
          return
        }
       await this.$router.push({name:'midterm-completed-students',params:{id:classId}})
      }catch (e) {
        this.$message({
          showClose: true,
          message: 'nộp bài thất bại',
          type: 'error',
          duration: 5000
        });
      }finally {
        this.loading = false
      }
    },
    async getExamAnswerMidtermTest() {
      try {
        
        const payload = {marking_retake_id: this.$route.params.id}
        const data = await this.$store.dispatch(GET_EXAM_ANSWER_MIDTERM_TEST, payload)
        let AIResult = null
        let ConfidenceAI = null
        let overallScoreAI = null
        let DataAI = null
        try {
          const response = await this.$store.dispatch(GET_WRITING_AI_RESULT, this.$route.params.id)
          DataAI = response?.data??[]
         
        } catch (e) {
          console.log("Error fetching AI result:", e);
        }
        console.log("dataaaaaaaa", data);
        const isSingleWriting = data?.data?.writings?.length === 1
        const writingPart = data?.data?.writings?.map((writing,index) => ({
            testType: this.WRITING,
            question: writing?.question,
            image: writing?.image,
            userAnswer: writing?.answer,
          evaluation: JSON.parse(JSON.stringify(this.getTemplate(data?.data?.rubric?.key, this.WRITING, index, isSingleWriting))),
          cheating: { isCheating: false, PlagiarismRate: null, comment: '' },
          didStudentDo: { value: true }
        }));
        if(DataAI?.length > 0){
          writingPart.forEach((writing, index) => {
            AIResult = DataAI?.[index].score_breakdown ?? null
            console.log(AIResult)
            ConfidenceAI = DataAI?.[index].confidence
            overallScoreAI = DataAI?.[index].final_score
             let isAIMarkFull = (this.isLowBand && ConfidenceAI?.confidence_raw >= 9 && (overallScoreAI<6 || overallScoreAI>8 )) || (!this.isLowBand && ConfidenceAI?.raw_score >= 9 && overallScoreAI>4 )
            writing.isAI = isAIMarkFull
            const shouldDisableAIFields = isAIMarkFull && !this.isEntrance
            writing?.evaluation?.items?.forEach(item => {
              const ParentKeyAI = AIResult?.find(itemAI => itemAI?.key === item?.key)
              if(ParentKeyAI){
                item.comment_detail = ParentKeyAI?.comment
                item.disable = shouldDisableAIFields
                item.items?.forEach(itemChild => {
                  const ParentKeyChildAI = ParentKeyAI?.sub_criteria?.find(itemChildAI => itemChildAI?.key === itemChild?.key)
                  if(ParentKeyChildAI && isAIMarkFull){
                    itemChild.criterion_score = ParentKeyChildAI?.point??''
                    itemChild.comment_auto = itemChild?.items?.find(child => child?.score === ParentKeyChildAI?.point)?.comment ?? ''
                    itemChild.e_comment_auto =  itemChild?.items?.find(child=>child?.score === ParentKeyChildAI?.point)?.eComment??''    
                    itemChild.disable = true
                  }
                })
              }
            })
          })
        }
        const speakingPart = {
          testType: this.SPEAKING,
          questionsAndAnswers: data?.data?.speakings?.map(speaking => ({
            id: speaking?.id,
            content: speaking?.content,
            answer: speaking?.answer
          })),
          evaluation: JSON.parse(JSON.stringify(this.getTemplate(data?.data?.rubric?.key, this.SPEAKING))),
          cheating: { isCheating: false, PlagiarismRate: null, comment: '' },
          didStudentDo: {value: true},
          isAI: false
        };

        let markingData = [];
        if (this.isEntrance) {
          const hasSpeaking = data?.data?.speakings?.some(s => this.hasAnswer(s?.answer));
          const filteredWritingParts = writingPart.filter(w => this.hasAnswer(w?.userAnswer));
          if (hasSpeaking) markingData.push(speakingPart);
          if (filteredWritingParts.length) markingData.push(...filteredWritingParts);
        } else {
          markingData = [speakingPart, ...writingPart];
        }
        this.markingData = markingData;
        await this.getSpeakingAiResult();
      } catch (e) {

      }
    },
    hasAnswer(value) {
      return value != null && String(value).trim() !== '';
    },
    applySpeakingAiPrefill(aiResult) {
      const speakingPart = this.markingData.find((item) => item.testType === this.SPEAKING);
      if (aiResult?.status !== 'ready' || !speakingPart) return;

      if (aiResult.cheating) {
        speakingPart.cheating = aiResult.cheating;
      }

      const feedbackCriteria = Array.isArray(aiResult.evidence?.feedback?.criteria)
        ? aiResult.evidence.feedback.criteria
        : [];
      const feedbackByGroup = feedbackCriteria.reduce((feedback, criterion) => {
        if (criterion?.key) feedback[criterion.key] = criterion.comment;
        return feedback;
      }, {});
      const marksByGroup = Array.isArray(aiResult.teacher_marks)
        ? aiResult.teacher_marks.reduce((groups, mark) => {
          if (!groups[mark.key_parent]) groups[mark.key_parent] = {};
          groups[mark.key_parent][mark.key] = mark;
          return groups;
        }, {})
        : {};

      speakingPart.isAI = Boolean(aiResult.is_gate_passed);
      speakingPart.evaluation.items = speakingPart.evaluation.items.map((group) => {
        const groupMarks = marksByGroup[group.key] || {};
        const firstMark = Object.values(groupMarks)[0];
        return {
          ...group,
          comment_detail: firstMark?.comment_detail ?? feedbackByGroup[group.key] ?? group.comment_detail,
          items: group.items.map((item) => {
            const mark = groupMarks[item.key];
            if (!aiResult.is_gate_passed || !mark) return item;
            return {
              ...item,
              criterion_score: mark.score,
              comment_auto: mark.comment_auto || '',
              e_comment_auto: mark.e_comment_auto || ''
            };
          })
        };
      });
    },
    async getSpeakingAiResult() {
      const academicTaskId = this.$route.query.academic_task_id;
      if (!academicTaskId) return;

      try {
        const response = await this.$store.dispatch(GET_SPEAKING_AI_RESULT, academicTaskId);
        if (!response?.error) this.applySpeakingAiPrefill(response?.data);
      } catch (error) {
        // Keep the manual grading flow available if AI data cannot be loaded.
      }
    },
    getTemplate(rubricKey, examType, index = 0, isSingleWriting = false) {
      this.isLowBand = ['marking.basic', 'marking.pre', 'marking.basic.v3', 'marking.pre.v3'].includes(rubricKey)
      this.markingVersion = isV3Rubric(rubricKey) ? 3 : 2
      return getEvaluationTemplate(rubricKey, examType, index, isSingleWriting)
    },
    transformDataToSendAPI(data){
      return {
        cheating: !data?.cheating?.isCheating || !data?.didStudentDo.value ? {
          type: null,
          description: null
        } : {
          type: data?.cheating?.PlagiarismRate,
          description: data?.cheating?.comment
        },
        has_submitted: data?.didStudentDo.value,
        teacher_marks: data?.evaluation.items.flatMap((parentSkill) => {
          return parentSkill?.items?.map((childSkill) => {
            return {
              "key": childSkill?.key,
              "label": childSkill?.label,
              "score": childSkill?.criterion_score,
              "key_parent": parentSkill?.key,
              "comment_auto": childSkill?.comment_auto,
              "label_parent": parentSkill.label,
              "comment_detail": parentSkill.comment_detail,
              "e_comment_auto": childSkill?.e_comment_auto,
            }
          })
        })
      }
    },
    nextStep(){
      if(this.markingDataIndex === this.markingData.length - 1 ){
        this.saveAll()
      }else {
        this.nextQuestion()
      }
    },
  },

  async mounted() {
    await this.$store.dispatch(SET_BREADCRUMB, [
      { title: "Danh sách tác vụ" },
      { title: this.isEntrance ? "Chấm bài thi đầu khóa" : "Chấm bài thi giữa khóa"},
    ]);
    await this.getExamAnswerMidtermTest()
  }
}
</script>

<template>
  <div style="background-color: white; border-radius: 8px;" class="p-5">
    <header class="d-flex justify-content-between align-items-center pb-4" style="border-bottom: 1px grey solid;">
      <p class="mb-0" style="font-size: 16px; font-weight: bold">{{ studentName }}</p>
      <div class="d-flex align-items-center">
        <div v-for="(item,indexItem) in markingData" :key="indexItem" class="step-item">
          <div class="step-circle"
               :class="indexItem=== markingDataIndex?'step-current':'step-completed'">{{ indexItem + 1 }}
          </div>
          <span class="marking-badge" :class="item.isAI ? 'badge-ai' : 'badge-admin'">
            {{ item.isAI ? 'AI hỗ trợ chấm' : 'Admin chấm' }}
          </span>
        </div>
      </div>
      <div class="manager-step-question" style="width: 300px; display: flex;justify-content: right">
        <button v-if="markingDataIndex" type="button" class="btn btn-secondary" @click="backQuestion()">Câu trước
        </button>
        <button v-if="markingDataIndex === markingData.length - 1 " type="button" class="btn btn-primary"
                @click="saveAll()" :disabled="checkDisabledNext || loading"><i v-if="loading" class="el-icon-loading"></i>Lưu
        </button>
        <button v-else type="button" class="btn btn-success" @click="nextQuestion()" :disabled="checkDisabledNext">Câu tiếp</button>
      </div>
    </header>
    <section class="row py-5">
      <div class="col-5">
        <StudentWritingSubmission v-if="currenMarkingData?.testType === WRITING"
                                  :currenMarkingData="currenMarkingData"></StudentWritingSubmission>
        <StudentSpeakingSubmission v-if="currenMarkingData?.testType === SPEAKING"
                                   :currenMarkingData="currenMarkingData"
                                   :autoplay="true"></StudentSpeakingSubmission>
      </div>
      <div class="col-7">
        <evaluation :evaluationData="currenMarkingData?.evaluation"
                    :cheating="currenMarkingData?.cheating" :didStudentDo="currenMarkingData?.didStudentDo"
                    :isAI="currenMarkingData?.isAI"
                    :isEntrance="isEntrance"
                    @nextStep="nextStep"></evaluation>
      </div>
    </section>

  </div>
</template>

<style scoped>
.step-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 0 8px;
}

.step-circle {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  text-align: center;
  line-height: 30px;
  font-weight: bold;
  color: white;
}

.marking-badge {
  font-size: 11px;
  padding: 2px 8px;
  border-radius: 4px;
  margin-top: 5px;
  font-weight: 500;
  white-space: nowrap;
}

.badge-ai {
  background-color: #52c41a;
  color: white;
}

.badge-admin {
  background-color: #b37feb;
  color: white;
}

.step-completed {
  background-color: #dcdcdc; /* xanh lá */
  color: black;
}

.step-current {
  background-color: #0275d8; /* xanh dương */
}

.step-container {
  border: 2px solid #0d6efd;
  padding: 5px 10px;
  display: inline-flex;
  border-radius: 4px;
}

.manager-step-question > * + * {
  margin-left: 20px; /* tương đương space-x-4 */
}

</style>
